module.exports = __webpack_public_path__ + "img/to-p.a28b2604.svg";